import EvOverviewPage from './pages/EvOverviewPage';
import EvReportPage from './pages/EvReportPage';
import LeadLayout from "./pages/EvLayout.vue";

export const evChildrenRoutes = (prefix = "") => [
  {
    name: "EvOverviewPage",
    path: "/",
    component: EvOverviewPage
  },
  {
    name: "EvReportPage",
    path: "report",
    component: EvReportPage
  }
];

export const evRoutes = {
  path: "evparking",
  component: LeadLayout,
  children: [
    ...evChildrenRoutes()
  ]
};



// WEBPACK FOOTER //
// ./src/features/ev-parking/routes.js